import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HomeHero from "@/pages/home/components/HomeHero";
import FlashFeed from "@/pages/home/components/FlashFeed";
import TopicWall from "@/pages/home/components/TopicWall";
import CollectionIndex from "@/pages/home/components/CollectionIndex";
import ScoopGrid from "@/pages/home/components/ScoopGrid";
import EvidenceChain from "@/pages/home/components/EvidenceChain";
import CommunityBoard from "@/pages/home/components/CommunityBoard";
import EditorColumn from "@/pages/home/components/EditorColumn";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 w-full pb-14 md:pb-20">
        <HomeHero />
        <FlashFeed />
        <TopicWall />
        <CollectionIndex />
        <ScoopGrid />
        <EvidenceChain />
        <CommunityBoard />
        <EditorColumn />
      </main>
      <SiteFooter />
    </div>
  );
}